// Escapes Postgres ILIKE's wildcard characters ("%" matches any run of
// characters, "_" matches any single character, "\" is the escape char
// itself) so a value containing them is matched literally.
//
// Used by create_todo's list-name lookup (issue #691): the value being
// escaped is model input echoing what she said in chat, so a list literally
// named e.g. "50% off" or "grocery_list" must not be treated as a pattern —
// that would match unrelated lists (or none at all) instead of the one she
// meant. A Copilot review on that PR caught the unescaped call.
export function escapeIlikeWildcards(s: string): string {
  return s.replace(/[%_\\]/g, (c) => `\\${c}`);
}
